import { render, staticRenderFns } from "./AddImageFromUploadModal.vue?vue&type=template&id=28cf2478&scoped=true"
import script from "./AddImageFromUploadModal.vue?vue&type=script&lang=js"
export * from "./AddImageFromUploadModal.vue?vue&type=script&lang=js"
import style0 from "./AddImageFromUploadModal.vue?vue&type=style&index=0&id=28cf2478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf2478",
  null
  
)

export default component.exports